import React, { Component } from 'react';
import styles from './PageSection.module.css';
import PageLayout from '../PageLayout/PageLayout.js';
import ContentPager from '../ContentPager/ContentPager.js';

class PageSection extends Component{
	state={
		increment:0
	}

	setContentIncrement=(increment)=>{
		this.setState(state=>{ 
			return {
				increment:state.increment+increment
			}
		});
	}

	render(){
		let pager=null;
		if(this.props.data.Pager===true) 
			pager=<ContentPager update={this.setContentIncrement} length={this.props.children.length} increment={this.state.increment} page_size={this.props.data.PageSize} />;

		let header=null;
		if(this.props.data.Header===true)
			header=<h1 className={styles.title}>{this.props.data.Title}</h1>;
		
		return(
			<React.Fragment>
				<div className={[styles.section,this.props.last===true?styles.last:null,this.props.position>0?styles.hide_mobile:styles.first,this.props.layout==='CALLOUT'?styles.no_border:null].join(' ')}>
					{header}
					<div className={styles.content}>
						<PageLayout Title={this.props.data.Title} layout={this.props.layout} increment={this.state.increment} sort={true} hide_content={this.props.data.hide_content}>
							{this.props.children}
						</PageLayout>
					</div>
					{pager}
				</div>
			</React.Fragment>
		);
	}
}

export default PageSection;